import BotConditionCard from "./BotConditionCard";
import React, {useEffect, useState} from "react";
import {useWatch} from "react-hook-form";
import ReactHookFormChipInput from "../../input/ReactHookFormChipInput";
import ReactHookFormCheckbox from "../../input/ReactHookFormCheckbox";
import ReactHookFormRadio from "../../input/ReactHookFormRadio";
import {Add, Delete} from "@mui/icons-material";
import {Box, Button, IconButton} from "@mui/material";

// Config array matching your unified flat keys pattern
const CustomInputs = [
    {label: "Custom 1", conType: "custom1"},
    {label: "Custom 2", conType: "custom2"},
    {label: "Custom 3", conType: "custom3"},
    {label: "Custom 4", conType: "custom4"},
    {label: "Custom 5", conType: "custom5"},
    {label: "Custom 6", conType: "custom6"},
    {label: "Custom 7", conType: "custom7"},
    {label: "Custom 8", conType: "custom8"},
    {label: "Custom 9", conType: "custom9"},
    {label: "Custom 10", conType: "custom10"}
];

// Main wrapper to map through all custom condition blocks dynamically
export default function BotConditionCustom(props) {
    const {control, setValue, getValues} = props;

    return (
        <>
            {CustomInputs.map((obj) => (
                <CustomConditionItem
                    key={obj.conType}
                    obj={obj}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                />
            ))}
        </>
    );
}

// Individual custom condition item component
function CustomConditionItem({obj, control, setValue, getValues}) {
    const [customInputLabel, setCustomInputLabel] = useState(obj.label);

    // Watch global rules layout directly from top form controller context
    const rules = useWatch({control, name: "rules"}) || {};
    const customData = rules?.[obj.conType];
    const hasCustomCondition = !!customData;

    const radioConditions = [
        {label: "Is", value: "is", color: "primary"},
        {label: "Is not", value: "isNot", color: "error"},
        {label: "Contains", value: "contains", color: "primary"},
        {label: "Not contain", value: "notContain", color: "error"},
    ];

    // Dynamic traffic source configuration mapping for label rendering hooks
    useEffect(() => {
            setCustomInputLabel(obj.label);
    }, [obj.conType, obj.label]);

    // REMOVE: Pure JS object field delete configuration approach
    const removeCondition = () => {
        const currentRules = {...getValues("rules")};
        delete currentRules[obj.conType];
        setValue("rules", currentRules);
    };

    // ADD: Set standard flat format fields map matching other view nodes
    const addCondition = () => {
        setValue(`rules.${obj.conType}`, {
            condition: "is",
            includeEmptyValue: false,
            values: []
        });
    };

    const renderAddCondition = () => {
        if (!hasCustomCondition) {
            return (
                <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                    <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                        <span>{customInputLabel}</span>
                    </Box>
                    <Box>
                        <Button
                            aria-label={`Add ${customInputLabel} condition`}
                            color="primary"
                            title="Add condition"
                            startIcon={<Add/>}
                            onClick={addCondition}
                            sx={{textTransform: "none", py: 0.25, px: 1}}
                        >
                            Add condition
                        </Button>
                    </Box>
                </Box>
            );
        }
    };

    const renderConditionBox = () => {
        if (hasCustomCondition) {
            return (
                <>
                    <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                        <Box flexGrow={1} sx={{minWidth: 0, fontSize: 14, fontWeight: 600}}>
                            {customInputLabel}
                        </Box>
                        <Box>
                            <IconButton
                                aria-label={`Remove ${customInputLabel} condition`}
                                color="default"
                                title="Remove"
                                size="small"
                                onClick={removeCondition}
                                sx={{color: 'error.dark'}}
                            >
                                <Delete fontSize="small"/>
                            </IconButton>
                        </Box>
                    </Box>
                    <Box>
                        <ReactHookFormRadio
                            control={control}
                            options={radioConditions}
                            name={`rules.${obj.conType}.condition`}
                            label="conditions"
                        />
                    </Box>
                    <Box>
                        <ReactHookFormCheckbox
                            control={control}
                            label="Include empty value"
                            labelPlacement="end"
                            name={`rules.${obj.conType}.includeEmptyValue`}
                        />
                    </Box>
                    <Box sx={{mt: 1}}>
                        <ReactHookFormChipInput
                            control={control}
                            name={`rules.${obj.conType}.values`}
                            label={`${customInputLabel} values`}
                            placeholder="Type a value and press Enter"
                        />
                    </Box>
                </>
            );
        }
    };

    return (
        <BotConditionCard>
            {renderAddCondition()}
            {renderConditionBox()}
        </BotConditionCard>
    );
}
